if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.preloadImages();
      }

      preloadImages() {
        // Preload images when modal is first created
        const images = this.querySelectorAll('img[data-high-res]');
        images.forEach(img => {
          const highRes = img.dataset.highRes;
          if (highRes) {
            const preloadLink = document.createElement('link');
            preloadLink.rel = 'preload';
            preloadLink.as = 'image';
            preloadLink.href = highRes;
            document.head.appendChild(preloadLink);
          }
        });
      }

      show(opener) {
        if (typeof opener === 'string') {
          const mediaId = opener;
          opener = this.querySelector(`[data-media-id="${mediaId}"]`)?.closest('.product__modal-opener');
        }

        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {

        if (!this.openedBy) return;

        const mediaId = this.openedBy.getAttribute('data-media-id') ||
                       this.openedBy.querySelector('[data-media-id]')?.getAttribute('data-media-id');

        if (!mediaId) return;

        // Remove active class from all media elements
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('active');
          if (element.tagName === 'IMG') {
            element.loading = 'lazy';
          }
        });

        // Find and activate the clicked media
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        if (activeMedia.tagName === 'IMG') {
          activeMedia.loading = 'eager';
          const highRes = activeMedia.dataset.highRes;
          if (highRes && activeMedia.src !== highRes) {
            activeMedia.src = highRes;
          }
        }

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        // Preload adjacent images
        this.preloadAdjacentImages(activeMedia);
      }

      preloadAdjacentImages(activeMedia) {
        // Find the next and previous images
        const allImages = Array.from(this.querySelectorAll('img[data-media-id]'));
        const currentIndex = allImages.indexOf(activeMedia);

        // Preload next image
        if (currentIndex < allImages.length - 1) {
          const nextImage = allImages[currentIndex + 1];
          const highRes = nextImage.dataset.highRes;
          if (highRes) nextImage.src = highRes;
        }

        // Preload previous image
        if (currentIndex > 0) {
          const prevImage = allImages[currentIndex - 1];
          const highRes = prevImage.dataset.highRes;
          if (highRes) prevImage.src = highRes;
        }
      }
    }
  );
}
